import React from "react";

export const EmptyBox = ({ width = "48px", height = "48px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 48 48"
    >
      <g>
        <linearGradient
          id="a"
          x1="5.5"
          x2="5.5"
          y1="46.16"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#54a5ff"></stop>
          <stop offset="1" stopColor="#8ad3fe"></stop>
        </linearGradient>
        <linearGradient id="c" x1="42.5" x2="42.5" y1="46.16"></linearGradient>
        <linearGradient id="d" x1="24" x2="24" y1="47" y2="31"></linearGradient>
        <linearGradient id="e" x1="24" x2="24" y1="27"></linearGradient>
        <linearGradient
          id="b"
          x1="24"
          x2="24"
          y1="21.38"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#d3e6f5"></stop>
          <stop offset="1" stopColor="#f0f7fc"></stop>
        </linearGradient>
        <linearGradient id="f" x1="4" x2="12" y1="41" y2="41"></linearGradient>
        <path
          fill="#4795ea"
          d="M46.62 46.16A2 2 0 0 1 45 47H3a2 2 0 0 1-1.62-.84C9.28 28.59 7.64 32.24 10 27h28c2.54 5.65.66 1.48 8.62 19.16z"
          opacity="1"
        ></path>
        <path
          fill="url(#a)"
          d="M10 14v13c-2.54 5.65-.66 1.48-8.62 19.16A1.9 1.9 0 0 1 1 45V31z"
          opacity="1"
        ></path>
        <path
          fill="url(#a)"
          d="M47 31v14a1.9 1.9 0 0 1-.38 1.16C38.72 28.59 40.36 32.24 38 27V14z"
          opacity="1"
        ></path>
        <path
          fill="url(#a)"
          d="M47 31v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V31h17.09a1 1 0 0 1 1 .85 5 5 0 0 0 8.47 2.69 5.06 5.06 0 0 0 1.39-2.69 1 1 0 0 1 1-.85z"
          opacity="1"
        ></path>
        <path fill="url(#a)" d="M10 14h28v13H10z" opacity="1"></path>
        <path
          fill="url(#b)"
          d="M33 10a9 9 0 1 0-10.57 8.85l1.12 2.26a.51.51 0 0 0 .9 0l1.12-2.26A9 9 0 0 0 33 10z"
          opacity="1"
        ></path>
        <path
          fill="#ffb369"
          d="m25.41 10 2.3-2.29a1 1 0 1 0-1.42-1.42L24 8.59l-2.29-2.3a1 1 0 0 0-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 0 0 1.42 1.42l2.29-2.3 2.29 2.3a1 1 0 0 0 1.42-1.42z"
          opacity="1"
        ></path>
        <rect
          width="8"
          height="6"
          x="4"
          y="38"
          fill="url(#f)"
          rx="1"
          opacity="1"
        ></rect>
        <path
          fill="#ffb369"
          d="M9 42H7a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z"
          opacity="1"
        ></path>
        <g fill="#4795ea">
          <path
            d="M17 44h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2zM19 40h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z"
            fill="#4795ea"
            opacity="1"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const Filter = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.38589 5.66687C2.62955 4.82155 2.25138 4.39889 2.23712 4.03968C2.22473 3.72764 2.35882 3.42772 2.59963 3.22889C2.87684 3 3.44399 3 4.57828 3H19.4212C20.5555 3 21.1227 3 21.3999 3.22889C21.6407 3.42772 21.7748 3.72764 21.7624 4.03968C21.7481 4.39889 21.3699 4.82155 20.6136 5.66687L14.9074 12.0444C14.7566 12.2129 14.6812 12.2972 14.6275 12.3931C14.5798 12.4781 14.5448 12.5697 14.5236 12.6648C14.4997 12.7721 14.4997 12.8852 14.4997 13.1113V18.4584C14.4997 18.6539 14.4997 18.7517 14.4682 18.8363C14.4403 18.911 14.395 18.9779 14.336 19.0315C14.2692 19.0922 14.1784 19.1285 13.9969 19.2012L10.5969 20.5612C10.2293 20.7082 10.0455 20.7817 9.89802 20.751C9.76901 20.7242 9.6558 20.6476 9.583 20.5377C9.49975 20.4122 9.49975 20.2142 9.49975 19.8184V13.1113C9.49975 12.8852 9.49975 12.7721 9.47587 12.6648C9.45469 12.5697 9.41971 12.4781 9.37204 12.3931C9.31828 12.2972 9.2429 12.2129 9.09213 12.0444L3.38589 5.66687Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Upload = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_9656_10345)">
        <rect x="2" y="1" width="24" height="24" rx="7" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          width="23"
          height="23"
          rx="6.5"
          stroke="#E5E5E5"
        />
        <g clipPath="url(#clip0_9656_10345)">
          <path
            d="M11.9997 15L13.9997 13L15.9997 15M13.9997 13V17.5M18.1947 16.195C18.6824 15.9291 19.0677 15.5084 19.2897 14.9993C19.5117 14.4902 19.5578 13.9216 19.4208 13.3833C19.2838 12.8451 18.9715 12.3677 18.5331 12.0267C18.0947 11.6857 17.5552 11.5004 16.9997 11.5H16.3697C16.2184 10.9146 15.9363 10.3712 15.5447 9.91049C15.1531 9.44982 14.6622 9.08392 14.1088 8.8403C13.5554 8.59667 12.954 8.48167 12.3498 8.50393C11.7456 8.52619 11.1543 8.68514 10.6203 8.96882C10.0864 9.25251 9.62369 9.65354 9.26705 10.1418C8.9104 10.63 8.66908 11.1928 8.56123 11.7877C8.45337 12.3826 8.48179 12.9943 8.64434 13.5766C8.8069 14.159 9.09936 14.6969 9.49974 15.15"
            stroke="#525252"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_9656_10345"
          x="0"
          y="0"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9656_10345"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9656_10345"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_9656_10345">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(8 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
